import React, {Component} from 'react';
import logo from './logo.svg';
import './App.css';
import './ZIndices.css';
import NavMenu from './components/NavMenu';
import SitePlans from './components/SitePlans';
import Footer from './components/Footer';
import GoogleAnalytics from './google/GoogleAnalytics';
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import AssetsManager from './assets_management/AssetsManager';
import Tutorials from './tutorials/Tutorials';
import isMobile from './core/isMobile';
import './site_specific/current/CssVariables.css';
import './site_specific/current/Fonts.css';
import { stopReportingRuntimeErrors } from "react-error-overlay";

if (process.env.NODE_ENV === "development") {
  stopReportingRuntimeErrors(); // disables error overlays
}
Sentry.init({
  dsn: AssetsManager.configuration.sentryDSN,
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});
export default class App extends Component{
	constructor(props){
		super(props);
		this._appRef=React.createRef();
	}
	componentDidMount() {
		
		this._googleAnalytics = new GoogleAnalytics({
			trackingCode:AssetsManager.configuration.googleAnalyticsTrackingCode,
			siteSlug:AssetsManager.configuration.siteSlug
		});
		const sitePlans = new SitePlans();
		this._appRef.current.appendChild(sitePlans.element);
		if(window.isMobile)
			document.body.classList.add('mobile');
		sitePlans.initialize();
		//Tutorials.generalWalkthrough();
	}
	render(){
		return (
			<div className="app noselect" ref={this._appRef}>
			  <header className="App-header">
			  <meta name="viewport" content='width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0' />
			  </header>
			</div>
		);
	}
}
